<div class="page hug-pre-engagement">
  <main class="mContent overflow-auto overflow-x-hidden">
    <app-section-loader [loading]="loading"></app-section-loader>
    <section class="pre-engage-header">
      <h2 class="pre-engage-header__title">
        {{lessonName}}
      </h2>
      <div class="pre-engage-header__buttons">
         <!-- <button mat-raised-button color="white" class="hug-main-button">
          Help
        </button> -->
        <button mat-raised-button color="white" class="hug-main-button" (click)="tutorTipModalOpen(true)">
          <img src="../../../assets/assets/images/svg/info-blue.svg" alt="Info icon">
          Tutor Tips
        </button>
      </div>
    </section>

    <nav class="hug-psc-navigation">
      <div class="hug-psc-navigation__nav">
        <button (click)="onBackClick()" [disabled]="isSavingLoader">
          <p>Back</p>
          <img src="../../../assets/assets/images/svg/arrow-back.svg" alt="previous">
          <p>H.U.G Classroom</p>
        </button>
      </div>

      <div class="hug-psc-navigation__container">
        <h2 class="hug-h2 text-center text-primary" style="font-size: 30px;">
          Before H.U.G. Lesson
        </h2>
      </div>

      <div class="hug-psc-navigation__nav">
        <button (click)="onNextClick(updateStudentProgressGroup.value)">
          <p>Next</p>
          <app-button-loader [isLoading]="isSavingLoader" *ngIf="isSavingLoader"></app-button-loader>
          <img src="../../../assets/assets/images/svg/arrow-next.svg" alt="next" *ngIf="!isSavingLoader">
          <p>Passage 1</p>
        </button>
      </div>
    </nav>

    <app-section-loader [loading]="loading"></app-section-loader>
    <form [formGroup]="updateStudentProgressGroup">
      <div class="hug-tutor-bg mat-typography">
        <section class="hug-tutor-attempts">
          <div class="hug-container">
            <h2 class="hug-h2 text-center text-primary" style="font-size: 24px;">
              Step 1: Student Pre-Lesson Engagement <span class="text-danger">*</span>
            </h2>
            <h1 class="hug-h1 text-center mb-4">
              Are you ready to learn today?
            </h1>


            <ul class="hug-tutor-smiley">
              <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_first.value == 1     
                " (click)="setMoodValue(1, 'mood_first')">
                <div class="hug-smiley hug-smiley--verySad">
                  <div class="hug-smiley__face">
                    <span class="hug-smiley__eyeLeft"></span>
                    <span class="hug-smiley__eyeRight"></span>
                    <div class="hug-smiley__mouth"></div>
                  </div>
                </div>
                <span class="hug-tutor-smiley__name">1</span>
                <span class="hug-tutor-smiley__text hug-text-style">Not Ready At All</span>
              </li>
              <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_first.value == 2
                " (click)="setMoodValue(2, 'mood_first')">
                <div class="hug-smiley hug-smiley--sad">
                  <div class="hug-smiley__face">
                    <span class="hug-smiley__eyeLeft"></span>
                    <span class="hug-smiley__eyeRight"></span>
                    <div class="hug-smiley__mouth"></div>
                  </div>
                </div>
                <span class="hug-tutor-smiley__name">2</span>
                <span class="hug-tutor-smiley__text hug-text-style">A Little Ready</span>
              </li>
              <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_first.value == 3
                " (click)="setMoodValue(3, 'mood_first')">
                <div class="hug-smiley hug-smiley--neutral">
                  <div class="hug-smiley__face">
                    <span class="hug-smiley__eyeLeft"></span>
                    <span class="hug-smiley__eyeRight"></span>
                    <div class="hug-smiley__mouth"></div>
                  </div>
                </div>
                <span class="hug-tutor-smiley__name">3</span>
                <span class="hug-tutor-smiley__text hug-text-style">Somewhat Ready</span>
              </li>
              <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_first.value == 4
                " (click)="setMoodValue(4, 'mood_first')">
                <div class="hug-smiley hug-smiley--happy">
                  <div class="hug-smiley__face">
                    <span class="hug-smiley__eyeLeft"></span>
                    <span class="hug-smiley__eyeRight"></span>
                    <div class="hug-smiley__mouth"></div>
                  </div>
                </div>
                <span class="hug-tutor-smiley__name">4</span>
                <span class="hug-tutor-smiley__text hug-text-style">Mostly Ready</span>
              </li>
              <li class="hug-tutor-smiley__card" [class.active]="
                  updateStudentProgressGroup.controls.mood_first.value == 5
                " (click)="setMoodValue(5, 'mood_first')">
                <div class="hug-smiley hug-smiley--veryHappy">
                  <div class="hug-smiley__face">
                    <span class="hug-smiley__eyeLeft"></span>
                    <span class="hug-smiley__eyeRight"></span>
                    <div class="hug-smiley__mouth"></div>
                  </div>
                </div>
                <span class="hug-tutor-smiley__name">5</span>
                <span class="hug-tutor-smiley__text hug-text-style">Very Ready</span>
              </li>
            </ul>

            <hr />

            <div class="d-flex flex-column align-items-center w-100 mt-8">
              <div class="d-flex align-items-center">
                <h2 class="hug-h2 text-center text-primary mb-0 mr-4" style="font-size: 24px;">
                Step 2: Complete The BE THE DIFFERENCE&trade; Form
              </h2>
            </div>
            <button mat-raised-button color="primary" class="hug-main-button miro-btn mt-4" (click)="onBeTheDifferenceClick()">
              BE THE DIFFERENCE&trade;
            </button>
              
              <h3 class="hug-h5 text-center hug-text mt-8">
                Did you complete the BE THE DIFFERENCE&trade; activity?
                <span class="text-danger">*</span>
              </h3>

              <mat-radio-group class="hug-radio-group hug-custom-margin hug-custom-margin-lg"
                aria-label="be_the_diff_complete" formControlName="be_the_diff_complete" [disabled]="isSavingLoader">
                <mat-radio-button [value]="1" (keydown.enter)="$event.preventDefault()">Yes</mat-radio-button>
                <mat-radio-button [value]="2" (keydown.enter)="$event.preventDefault()">No</mat-radio-button>
              </mat-radio-group>

            </div>
          </div>
        </section>


      </div>
    </form>

    <div class="modal" [ngClass]="{'active':tutorTipModal}" id="modalExample">
      <div class="modal__box">
        <div class="modal__header">
          <h2>Tutor Tips</h2>
          <button class="close" aria-label="Close" (click)="tutorTipModalOpen(false)">×</button>
        </div>
        <div class="modal__body">
          <p [innerHTML]="tutorTip"></p>
        </div>
      </div>
    </div>

    <div class="modal" [ngClass]="{'active':noBtdFormModal}" id="noBtdFormModal">
      <div class="modal__box">
        <div class="modal__header">
          <h2>No BE THE DIFFERENCE&trade; Form</h2>
          <button class="close" aria-label="Close" (click)="noBtdFormModalOpen(false)">×</button>
        </div>
        <div class="modal__body">
          <ul>
            <li>There is no BE THE DIFFERENCE&trade; Form assigned for this week.</li>
            <li>Please contact the Online Specialist, then answer &quot;Yes&quot; and continue with the lesson.</li>
          </ul>
        </div>
      </div>
    </div>
  </main>

  <footer class="hug-tutor-footer">
    <div class="hug-container">
      <p class="hug-copyright">© Help Us Grow Reading Program</p>
    </div>
  </footer>
</div>